import styled from 'styled-components';

import { ProgressBar } from '@xing-com/progress-bar';
import {
  spaceXS,
  spaceS,
  spaceM,
  cornerRadiusXL,
  xdlColorIllustrationBackground,
  xdlColorTextOnLight,
} from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

const Item = styled.a`
  text-decoration: none;
  color: ${xdlColorTextOnLight};
  background-color: ${xdlColorIllustrationBackground};
  border-radius: ${cornerRadiusXL};
  display: flex;
  justify-content: space-between;
  padding: ${spaceXS} ${spaceM};
  height: 32px;
  width: 100%;
  margin-bottom: ${spaceM};
`;

const ItemContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  width: 100%;
  overflow: hidden;
`;

const ItemLabel = styled(BodyCopy)`
  color: ${xdlColorTextOnLight};
  margin: 0;
  flex: 0 1 100%;
  white-space: nowrap;
`;

const Title = styled(Headline)<{ $isBlurred?: boolean }>`
  margin: 0 ${spaceXS} 0 0;
  filter: ${({ $isBlurred }) => ($isBlurred ? 'blur(4px)' : 'none')};
  color: ${xdlColorTextOnLight};
`;

const VisualElement = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
`;

const TilesProgressBar = styled(ProgressBar)`
  width: 64px;
  margin: 0 ${spaceS};
  flex: 0 100%;
`;

export default {
  Item,
  ItemContent,
  ItemLabel,
  Title,
  VisualElement,
  TilesProgressBar,
};
